import type { Theme } from '@material-ui/core';
import {
  Box, createStyles, Divider, Grid, LinearProgress, makeStyles, Paper, Typography,
} from '@material-ui/core';
import * as React from 'react';
import type { GridColDef, GridSortModel } from '@material-ui/data-grid';
import { DataGrid } from '@material-ui/data-grid';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import type { IRepairResult } from './RepairLookupInterfaces';

const useStyles = makeStyles((theme: Theme) => createStyles({
  loading: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));
interface IRepairResultsProps {
  loading: boolean;
  resultSet: Array<IRepairResult>;
  gridTitle?: string;
  preSortGrid?: GridSortModel;
}

const RepairResults: React.FC<IRepairResultsProps> = ({
  resultSet, loading, gridTitle = 'Repair Results', preSortGrid,
}) => {
  const classes = useStyles();

  const columns : GridColDef[] = [
    {
      field: 'repairItemId', headerName: '', width: -1, hide: true,
    },
    { field: 'barcode', headerName: 'Barcode', flex: 1 },
    {
      field: 'shipLog',
      headerName: 'ShipLog',
      flex: 0.75,
      renderCell: ({ value }) => (value ? <LocalShippingIcon color="error" fontSize="large" /> : ''),
    },
    { field: 'storeRepairNumber', headerName: 'Store Repair Number', flex: 1.2 },
    { field: 'company', headerName: 'Company', flex: 1 },
    { field: 'store', headerName: 'Store', flex: 1 },
    { field: 'location', headerName: 'Location', flex: 1 },
    {
      field: 'lastModified',
      headerName: 'Last Update',
      renderCell: ({ value }) => (
        ((typeof (value) === 'string')
          ? <>{new Date(value).toLocaleDateString() }</>
          : <>{value}</>
        )
      ),
      flex: 1,
    },
    {
      field: 'facility', headerName: 'Facility', flex: 1,
    },
    {
      field: 'assignedTo', headerName: 'Assigned To', flex: 1,
    },
  ];

  return (
    <Box>
      <Paper>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box pl={2}>
              <Typography variant="h6">{gridTitle}</Typography>
            </Box>
          </Grid>
          <Grid item xs={12} className={classes.loading}>
            {loading ? <LinearProgress /> : <Divider />}
          </Grid>
          <Grid item xs={12}>
            <Box style={{ height: '48vh', width: '100%' }}>
              <DataGrid
                getRowId={
                    (row) => (
                      // if theres no repairItems, then we use the barcode since it will be unique and repairItemId will be null
                      // eslint-disable-next-line no-nested-ternary
                      (typeof row.repairItemId === 'string' && typeof row.barcode === 'string')
                        ? row.repairItemId === '00000000-0000-0000-0000-000000000000' ? row.barcode : row.repairItemId
                        : String(row.repairItemId))
                }
                rows={resultSet}
                columns={columns}
                sortModel={preSortGrid}
              />
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Box>

  );
};

export default RepairResults;
